<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col xl="4" md="6">
        <apex-donut-chart />
      </b-col>
      <b-col xl="8" md="6">
        <!-- <chartjs-line-chart /> -->
        <apex-data-bar-chart-two />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <!-- Company Table Card -->
      <b-col lg="12">
        <apex-data-bar-chart />
      </b-col>
      <!--/ Company Table Card -->

      <!-- Developer Meetup Card -->
      <b-col lg="5" md="6">
        <!-- <chartjs-bar-chart /> -->
        <!-- <apex-data-bar-chart-two /> -->
      </b-col>
      <!--/ Developer Meetup Card -->
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import store from "@/store";
import { getUserData } from "@/auth/utils";
import EcommerceMedal from "./EcommerceMedal.vue";
import EcommerceStatistics from "./EcommerceStatistics.vue";
import EcommerceCompanyTable from "./EcommerceCompanyTable.vue";
import EcommerceMeetup from "./EcommerceMeetup.vue";
import ApexDonutChart from "../chart/ApexDonutChart.vue";
import ApexDataBarChart from "../chart/ApexDataBarChart.vue";
import ChartjsBarChart from "../chart-chartjs/ChartjsBarChart.vue";
import ChartjsLineChart from "../chart-chartjs/ChartjsLineChart.vue";
import dashboardStore from "./dashboardStoreModule";
import { ref, onUnmounted } from "@vue/composition-api";
import ApexDataBarChartTwo from "../chart/ApexDataBarChartTwo.vue";

export default {
  components: {
    BRow,
    BCol,
    EcommerceMedal,
    EcommerceStatistics,
    EcommerceCompanyTable,
    EcommerceMeetup,
    ApexDonutChart,
    ApexDataBarChart,
    ChartjsBarChart,
    ChartjsLineChart,
    ApexDataBarChartTwo,
  },
  data() {
    return {
      data: {},
    };
  },
  created() {
    // data
    this.$http.get("/ecommerce/data").then((response) => {
      this.data = response.data;

      // ? Your API will return name of logged in user or you might just directly get name of logged in user
      // ? This is just for demo purpose
      const userData = getUserData();
      this.data.congratulations.name =
        userData.fullName?.split(" ")[0] || userData.username;
    });
  },
  setup() {
    if (!store.hasModule("dashboard-seller"))
      store.registerModule("dashboard-seller", dashboardStore);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule("dashboard-seller"))
        store.unregisterModule("dashboard-seller");
    });
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
